import { FormControlLabel } from "@mui/material"
import LoaderSwitch from "components/Loaders/LoaderSwitch"
import { Android12Switch } from "components/Styled"

export const ActiveSwitch = ({ id, loadingUpdateActive, itemIdToUpdateActive, getActive, data, disabled, onClick  }) => {
  return (<>
    {(loadingUpdateActive && itemIdToUpdateActive === id) ?
      <LoaderSwitch on={getActive(id, data)} /> :
      <FormControlLabel sx={{ marginRight: 0 }} control={<Android12Switch checked={getActive(id, data)} disabled={disabled} onClick={() => onClick()} />} />
    }
  </>)
}